import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { WIDGET_REGISTRY, WidgetDefinition } from 'src/app/widgets/widget-registry';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

@Component({
  selector: 'app-add-widget-dialog',
  templateUrl: './add-widget-dialog.component.html',
  styleUrls: ['./add-widget-dialog.component.scss'],
  standalone: false
})
export class AddWidgetDialogComponent {
  readonly registry: readonly WidgetDefinition[];

  constructor(
    private dialogRef: MatDialogRef<AddWidgetDialogComponent, WidgetDefinition>,
    appConfig: AppConfigService
  ) {
    this.registry = WIDGET_REGISTRY.filter(
      (x) =>
        !x.requiredModule || appConfig.tenant.modules.some((m) => m.moduleType === x.requiredModule)
    );
  }

  select(definition: WidgetDefinition) {
    this.dialogRef.close(definition);
  }
}
